// import APIs
import { getEmployeesBasedOnCostCenters } from 'RestAPIs/cost-centers/employees';

// import external libraries
import { useQuery } from 'react-query';

// constants
import { EMPLOYEES_QUERY_KEY } from '../RosterPlan.consts';

export type GetEmployeesBasedOnCostCentersProps = {
  costCenters: string;
  startDate: string;
  endDate: string;
};

const useGetEmployeesBasedOnCostCenters = (
  { costCenters, startDate, endDate }: GetEmployeesBasedOnCostCentersProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    [EMPLOYEES_QUERY_KEY, costCenters, startDate, endDate],
    async () => {
      const { data } = await getEmployeesBasedOnCostCenters({
        costCenters,
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeesBasedOnCostCenters;
